export const Data=()=>{
    const data=[
        {
          id: 1,
          question: "Rolex is a company that specializes in what type of product?",
          answers: [
            { text: "Phone", correct: false },
            { text: "Watches", correct: true },
            { text: "Food", correct: false },
            { text: "Cosmetic", correct: false },
          ],
        },
        {
          id: 2,
          question: "What is the capital city of France?",
          answers: [
            { text: "Berlin", correct: false },
            { text: "Madrid", correct: false },
            { text: "Paris", correct: true },
            { text: "Rome", correct: false },
          ],
        },
        {
          id: 3,
          question: "When did the website `Facebook` launch?",
          answers: [
            { text: "2004", correct: true },
            { text: "2005", correct: false },
            { text: "2006", correct: false },
            { text: "2007", correct: false },
          ],
        },
        {
          id: 4,
          question: "Who played the character of Harry Potter in the movie?",
          answers: [
            { text: "Johnny Depp", correct: false },
            { text: "Leonardo DiCaprio", correct: false },
            { text: "Denzel Washington", correct: false },
            { text: "Daniel Radcliffe", correct: true },
          ],
        },
        {
          id: 5,
          question: "Which planet is known as the Red Planet?",
          answers: [
            { text: "Earth", correct: false },
            { text: "Mars", correct: true },
            { text: "Jupiter", correct: false },
            { text: "Saturn", correct: false },
          ],
        },
        {
          id: 6,
          question: "In which year did World War II end?",
          answers: [
            { text: "1942", correct: false },
            { text: "1945", correct: true },
            { text: "1946", correct: false },
            { text: "1950", correct: false },
          ],
        },
        {
          id: 7,
          question: "What is the largest mammal in the world?",
          answers: [
            { text: "Elephant", correct: false },
            { text: "Blue Whale", correct: true },
            { text: "Giraffe", correct: false },
            { text: "Great White Shark", correct: false },
          ],
        },
        {
          id: 8,
          question: "Which element is said to keep bones strong?",
          answers: [
            { text: "Iron", correct: false },
            { text: "Calcium", correct: true },
            { text: "Carbon", correct: false },
            { text: "Oxygen", correct: false },
          ],
        },
        {
          id: 9,
          question: "Who wrote the play 'Romeo and Juliet'?",
          answers: [
            { text: "Charles Dickens", correct: false },
            { text: "Mark Twain", correct: false },
            { text: "William Shakespeare", correct: true },
            { text: "Jane Austen", correct: false },
          ],
        },
        {
          id: 10,
          question: "What is the hardest natural substance on Earth?",
          answers: [
            { text: "Gold", correct: false },
            { text: "Iron", correct: false },
            { text: "Diamond", correct: true },
            { text: "Platinum", correct: false },
          ],
        },
        {
          id: 11,
          question: "Which is the smallest ocean in the world?",
          answers: [
            { text: "Indian Ocean", correct: false },
            { text: "Pacific Ocean", correct: false },
            { text: "Atlantic Ocean", correct: false },
            { text: "Arctic Ocean", correct: true },
          ],
        },
        {
          id: 12,
          question: "Which country gifted the Statue of Liberty to the USA?",
          answers: [
            { text: "Germany", correct: false },
            { text: "France", correct: true },
            { text: "Canada", correct: false },
            { text: "Italy", correct: false },
          ],
        },
        {
          id: 13,
          question: "Which planet is known as the Morning Star?",
          answers: [
            { text: "Mars", correct: false },
            { text: "Venus", correct: true },
            { text: "Jupiter", correct: false },
            { text: "Saturn", correct: false },
          ],
        },
        {
          id: 14,
          question: "What is the main ingredient in traditional guacamole?",
          answers: [
            { text: "Tomato", correct: false },
            { text: "Avocado", correct: true },
            { text: "Onion", correct: false },
            { text: "Lettuce", correct: false },
          ],
        },
        {
          id: 15,
          question: "What is the currency of Japan?",
          answers: [
            { text: "Yuan", correct: false },
            { text: "Yen", correct: true },
            { text: "Won", correct: false },
            { text: "Dollar", correct: false },
          ],
        },
      ]
      

      return data
    
}